var App = App || {};

App.AlertsSignUp = (function() {

    var cachedModals = {};

    return {
        init: init
    };

    function init() {
        if (!_myComponentIsOnPage()) {
            return;
        }
        initFrequencySelection();
        initQueryBuilder();
        initSearchTerms();
        initTaxonomyFacet();
        initCollectionsFacet();
        initAcceptedManuscripts();
        initAlerts();
        initAlertName();
        $('.js-alert-resources-modal').on('opened.fndtn.reveal', openModal);
        $('.js-alert-resources-modal').on('close.fndtn.reveal', closingModal); //This is the Close event for the Foundation framework modal      
    }

    function initAlerts() {
        const inputSelectorToCleanup = '.js-alert-search-terms .at-querybuilder-input';
        const oldInputs = document.querySelectorAll(inputSelectorToCleanup);

        oldInputs.forEach(oldInput => {
            const newInput = oldInput?.cloneNode(true);
            oldInput?.parentNode?.appendChild(newInput);
            oldInput?.remove();
        });

        const eventData = [
            {
                selector: '.js-bookAlertBody .js-submit-books-alert',
                eventType: 'click',
                handler: e => saveBooksAlert(e)
            },
            {
                selector: '.js-alerts-sign-up-wrapper .js-submit-journal-articles-alert',
                eventType: 'click',
                handler: e => saveJournalArticlesAlert(e)
            },
            {
                selector: '.js-nbnjArticlesAlertBody .js-submit-nbnj-articles-alert',
                eventType: 'click',
                handler: e => saveNbnjArticlesAlert(e)
            },
            {
                selector: '.js-submit-books-alert-input-wrapper',
                eventType: 'keyup',
                handler: e => handleEnterThenFocusButton(e, '.js-submit-books-alert')
            },
            {
                selector: '.js-journal-articles-alert-input-wrapper',
                eventType: 'keyup',
                handler: e => handleEnterThenFocusButton(e, '.js-submit-journal-articles-alert')
            },
            {
                selector: inputSelectorToCleanup,
                eventType: 'keyup',
                handler: e => handleEnterThenFocusButton(e, `#_text_${e.target.id.slice(-1)}`)
            },
        ];

        for (var event of eventData) {
            document.querySelectorAll(event.selector).forEach(
                n => n.addEventListener(event.eventType, event.handler)
            );
        }       
    }

    function handleEnterThenFocusButton(event, selector) {
        if (event.key === 'Enter') {
            event.stopImmediatePropagation();
            document.querySelector(selector)?.focus();
        }
    }

    function _myComponentIsOnPage() {
        return $('.js-alerts-sign-up-wrapper').length;
    }

    function initFrequencySelection() {
        var defaultSelectedValue = $('.js-new-alerts-frequency-select').val();
        if (defaultSelectedValue) {
            App.HistoryManager.Push('AlertScheduleID', [defaultSelectedValue]);
        }

        $('.js-new-alerts-frequency-select').on('change', applyFrequencySelection);
    }

    function applyFrequencySelection() {
        var selectedValue = $(this).val();
        var newUrl = App.HistoryManager.Push('AlertScheduleID', [selectedValue]);
        window.location.href = newUrl;
    }

    function initQueryBuilder() {
        $('.querybuilder-wrap').find('.error-message').text('').addClass('hide');
        $('.querybuilder-title').addClass('hide');
        $('.js-custom-queryBuilder').addClass('hide');
    }

    function initSearchTerms() {
        $('.js-close-button').on('click', removeSearchTerm);
        $('.js-apply-search-terms-button').on('click', applySearchTerm);
        $('.js-apply-search-terms-button').on('keypress', handleKeyPress);
    }

    function initTaxonomyFacet() {
        $('.js-apply-taxonomy-filter-button').on('click', applyTaxonomy);
        $('.js-apply-taxonomy-filter-button').on('keypress', handleKeyPress);
        $('.js-apply-series-taxonomy-filter-button').on('click', applySeriesTaxonomy);
        $('.js-apply-series-taxonomy-filter-button').on('keypress', handleKeyPress);
        App.TaxonomyFacet.initTaxonomyTree();
    }

    function initCollectionsFacet() {
        if (isCollectionFilterOnPage()) {
            $('.js-apply-collection-filter-button').on('click', applyCollections);
        }
    }

    function isCollectionFilterOnPage() {
        return $('.js-collections-wrap').length;
    }

    function initAcceptedManuscripts() {
        var defaultSelectedValue = $('.js-accepted-manuscript').is(':checked');
        if (defaultSelectedValue) {
            App.HistoryManager.Push('ExcludeAcceptedManuscript', [defaultSelectedValue]);
        }

        $('.js-accepted-manuscript').on('change', applyAcceptedManuscriptsSelection);
    }

    function applyAcceptedManuscriptsSelection(e) {
        var isChecked = $(e.currentTarget).is(':checked');
        var newUrl = App.HistoryManager.Push('ExcludeAcceptedManuscript', [isChecked]);
        window.location.href = newUrl;
    }

    function handleKeyPress(e) {
        if (e.which === 13) { // Enter key code
            $(this).click();
        }
    }

    function removeSearchTerm() {
        var $removeButton = $(this);
        var queryString = $removeButton.data('url');
        if (queryString) {
            var newUrl = getRedirectUrl(queryString);
            window.location.href = newUrl;
        }
    }

    function applySearchTerm() {
        var queryString = SCM.CustomQueryBuilder.queryBuilderHandler();
        if (queryString) {
            var newUrl = getRedirectUrl(queryString);
            window.location.href = newUrl;
        }
    }

    function getRedirectUrl(queryString) {
        var baseUrl = window.location.origin + window.location.pathname;
        var encodedQueryString = decodeURIComponent(queryString);
        var newUrl = baseUrl + "?" + encodedQueryString;
        return newUrl;
    }

    function applyTaxonomy() {
        var newUrl = App.TaxonomyFacet.getAlertModalTaxonomyUrl();
        if (newUrl) {
            window.location.href = newUrl;
        }
    }

    function applyCollections() {
        var queryString = SCM.CollectionFacet.getUpdateQueryStringUrl();
        if (queryString) {
            var newUrl = getRedirectUrl(queryString);
            window.location.href = newUrl;
        }
    }

    function applySeriesTaxonomy() {
        var newUrl = App.TaxonomyFacet.getAlertModalSeriesTaxonomyUrl();
        if (newUrl) {
            window.location.href = newUrl;
        }
    }

    function openModal() {
        var modalId = this.id;
        var $modal = $('#' + modalId);
        if ($modal.length) {
            cachedModals[modalId] = $modal.html();
        }
    }

    function closingModal() {
        var modal = this;
        if (modal) {
            var modalId = modal.id;
            if (cachedModals[modalId]) {
                modal.innerHTML = cachedModals[modalId];
                if (modal.id.startsWith('taxonomyFilterModal-')) {
                    initTaxonomyFacet();
                    App.TaxonomyFacet.initTaxonomyArrows($('.js-taxonomy-tree-wrap'));
                }
                else if (modal.id === 'searchTermsModal') {
                    initSearchTerms();
                    SCM.CustomQueryBuilder.init();
                }
            }
        }
    }

    function saveJournalArticlesAlert(event) {
        var $articlesAlert = $(event.target).closest('.js-journalArticleAlertBody');
        var postData = {
            searchName: $articlesAlert.find('#articleAlertName').val(),
            frequencyId: $articlesAlert.find('.js-new-alerts-frequency-select').val(),
            excludeAcceptedManuscripts: $articlesAlert.find('#acceptedManuscript').prop('checked'),
            alertUrl: window.location.href
        };

        var ajaxUrl = '//' + SCM.SearchResults.defaults.baseSiteUrl + '/AlertSignUp/CreateNewJournalArticlesAlert';
        SCM.Ajax.post(ajaxUrl, postData)
            .expectJson()
            .then((response) => {
                if (response.Success) {
                    if ($(".js-failure-alert-message").is(":visible")) {
                        removeErrorTextFromPageTitle();
                    }
                    showAlertSuccessMessage();
                }
                else if (response.Messages.length > 0) {
                    addErrorTextToPageTitle();
                    showAlertFailureMessages(response.Messages);
                }
            })
            .catch(function (error) {
                console.error('Saving journal articles alert has an error: ' + error);
            });
    }

    function saveBooksAlert(event) {
        var $booksAlert = $(event.target).closest('.js-bookAlertBody');
        var postData = {
            searchName: $booksAlert.find('#bookAlertName').val(),
            frequencyId: $booksAlert.find('.js-new-alerts-frequency-select').val(),
            alertUrl: window.location.href
        };

        var ajaxUrl = '//' + SCM.SearchResults.defaults.baseSiteUrl + '/AlertSignUp/CreateNewBooksAlert';
        SCM.Ajax.post(ajaxUrl, postData)
            .expectJson()
            .then((response) => {
                if (response.Success) {
                    if ($(".js-failure-alert-message").is(":visible")) {
                        removeErrorTextFromPageTitle();
                    }
                    showAlertSuccessMessage();
                }
                else if (response.Messages.length > 0) {
                    addErrorTextToPageTitle();
                    showAlertFailureMessages(response.Messages);
                }
            })
            .catch(function (error) {
                console.log(error.userFriendlyMessage);
            });
    }

    function saveNbnjArticlesAlert(event) {
        var $nbnjAlert = $(event.target).closest('.js-nbnjArticlesAlertBody');
        var postData = {
            searchName: $nbnjAlert.find('#articleAlertName').val(),
            frequencyId: $nbnjAlert.find('.js-new-alerts-frequency-select').val(),
            alertUrl: window.location.href,
            nbnjAlertType: $nbnjAlert.find('.js-submit-nbnj-articles-alert').data('alert-type-param')
        };

        var ajaxUrl = '//' + SCM.SearchResults.defaults.baseSiteUrl + '/AlertSignUp/CreateNewNbnjArticlesAlert';
        SCM.Ajax.post(ajaxUrl, postData)
            .expectJson()
            .then((response) => {
                if (response.Success) {
                    if ($(".js-failure-alert-message").is(":visible")) {
                        removeErrorTextFromPageTitle();
                    }
                    showAlertSuccessMessage();
                }
                else if (response.Messages.length > 0) {
                    addErrorTextToPageTitle();
                    showAlertFailureMessages(response.Messages);
                }
            })
            .catch(function (error) {
                console.log(error.userFriendlyMessage);
            });
    }

    function addErrorTextToPageTitle() {
        if (!document.title.startsWith("Error: ")) {
            document.title = "Error: " + document.title;
        }
    }

    function removeErrorTextFromPageTitle() {
        if (document.title.startsWith("Error: ")) {
            document.title = document.title.replace("Error: ", "");
        }
    }

    function showAlertSuccessMessage() {
        $('.js-failure-alert-message').addClass('hidden');
        $('.js-bookAlertBody').addClass('hidden'); 
        $('.js-journalArticleAlertBody').addClass('hidden');
        $('.js-nbnjArticlesAlertBody').addClass('hidden'); 
        $('.js-alert-name-error-message').addClass('hidden');
        $('.success-alert-message').removeClass('hidden');
        invalidateAlertNameCache();
    }

    function showAlertFailureMessages(messages) {
        if (!messages || messages.length === 0) {
            return;
        }
        $('.js-failure-alert-message').html(messages[0]).removeClass('hidden');

        // If there's a second message, display it above the Alert Name input.
        if (messages.length > 1) {
            var $alertNameInput = $('.js-alert-input-text');
            $alertNameInput.addClass('validation-error');
            $alertNameInput.focus();
            $('.js-alert-name-error-message').text(messages[1]).removeClass('hidden');
        }
        else {
            // If we don't have a second message anymore, hide the second message in case we showed it before.
            $('.js-alert-input-text').removeClass('validation-error');
            $('.js-alert-name-error-message').addClass('hidden');
        }
    }

    function initAlertName() {
        clearAlertNameCacheIfNeeded();

        setCachedAlertName();

        $('.js-alert-input-text')
            .on('input', function () {
                const alertName = $(this).val();
                cacheAlertName(alertName);
            })
            .on('blur', function () {
                const alertName = $(this).val();
                cacheAlertName(alertName);
            });
    }

    function clearAlertNameCacheIfNeeded() {
        const currentPageInSession = sessionStorage.getItem('current_page');
        const currentPage = window.location.pathname;

        if (currentPageInSession !== currentPage) {
            for (let i = 0; i < sessionStorage.length; i++) {
                const key = sessionStorage.key(i);
                if (key && key.startsWith("alert_cache_")) {
                    sessionStorage.removeItem(key);
                }
            }
        }

        sessionStorage.setItem('current_page', window.location.pathname);
    }

    function cacheAlertName(alertName) {
        const storageKey = getAlertNameStorageKey();
        sessionStorage.setItem(storageKey, alertName);
    }

    function setCachedAlertName() {
        const storageKey = getAlertNameStorageKey();
        const cachedAlertName = sessionStorage.getItem(storageKey);
        
        if (cachedAlertName) {
            $('.js-alert-input-text').val(cachedAlertName);
        }
    }

    function invalidateAlertNameCache() {
        const storageKey = getAlertNameStorageKey();
        sessionStorage.removeItem(storageKey);
    }

    function getAlertNameStorageKey() {
        const pathname = window.location.pathname;
        const prefix = "alert_cache_";
        return prefix + pathname;
    }
})(jQuery);